// Helpers to compute derived metrics for breakdown rows
export function computeUtilizationPct(plannedMinutes, loggedTotalMinutes) {
  const p = Number(plannedMinutes || 0);
  const l = Number(loggedTotalMinutes || 0);
  if (!p) return null;
  return Math.round((l * 10000) / p) / 100; // 2 decimals
}

export function overbookedFlag(totalMinutes) {
  const m = Number(totalMinutes || 0);
  return m > 8 * 60;
}

export function sortRows(rows, key, dir) {
  const arr = [...rows];
  arr.sort((a,b)=>{
    const av = a[key]; const bv = b[key];
    if (typeof av === 'string' || typeof bv === 'string') {
      return dir==='asc' ? String(av).localeCompare(String(bv)) : String(bv).localeCompare(String(av));
    }
    const na = Number(av || 0); const nb = Number(bv || 0);
    return dir==='asc' ? (na - nb) : (nb - na);
  });
  return arr;
}
